import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';

let domain = '';
if (window.location.href.includes(environment.demoDomain)) {
  domain = environment.demoDomain;
} else {
  domain = environment.localnonDemoDomain || environment.nonDemoDomain;
}

const redirectSignIn = `${domain}/${environment.redirectSignInSuffix}`;
const redirectSignOut = `${domain}/${environment.redirectSignOutSuffix}`;

amplifyconfig.oauth.redirectSignIn = redirectSignIn;
amplifyconfig.oauth.redirectSignOut = redirectSignOut;
amplifyconfig.oauth.domain = environment.authDomain;

Amplify.configure({
  ...amplifyconfig,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => {
    console.error('App Error:', err);
    if (err?.message.includes('Loading chunk')) {
      console.error('Error bootstrapping module:', err);
      window.location.reload();
    }
  });
